import React from 'react';
import { ArrowRight } from 'lucide-react';
import type { AICaseRecipe } from '../../studio/constants/subjectCatalog';
import { RECIPE_CATEGORIES } from '../../studio/constants/subjectCatalog';

interface UseCaseCardProps {
  useCase: AICaseRecipe;
  subjectHue: string;
  onSelect: (useCase: AICaseRecipe) => void;
}

export function UseCaseCard({ useCase, subjectHue, onSelect }: UseCaseCardProps) {
  const category = RECIPE_CATEGORIES[useCase.category];

  return (
    <button
      type="button"
      onClick={() => onSelect(useCase)}
      className="use-case-card group text-left"
      style={{ '--subject-hue': subjectHue } as React.CSSProperties}
    >
      <span className="use-case-card__icon">{useCase.icon}</span>
      <span className="use-case-card__body">
        <span className="use-case-card__badge">
          {category.icon} {category.label}
        </span>
        <span className="use-case-card__title">{useCase.title}</span>
        <span className="use-case-card__desc">{useCase.description}</span>
      </span>
      <span className="use-case-card__arrow" aria-hidden>
        <ArrowRight className="h-4 w-4" strokeWidth={2} />
      </span>
    </button>
  );
}
